import React from 'react'
import {Color} from '../Styles'
import styled from '@emotion/styled'

type LineProps = {
  children: React.ReactNode
  color?: string
}

const StyledSpan = styled.span`
  display: block;
  margin: 0px;
  padding: 0px;
  color: ${({color}: LineProps): string => color ?? Color.Grey800
};
`

export const Line: React.VFC<LineProps> = (props) =>
  <StyledSpan color={props.color}>{props.children}</StyledSpan>
